<template>
  <div class="main-div">
    <div class="heading-name">
      <img
        v-if="logo == 'userIcon'"
        height="20"
        width="20"
        src="../../../../assets/userDetails/userIcon.svg"
      />
      <img
        v-else-if="logo == 'thumbsup'"
        height="20"
        width="20"
        src="../../../../assets/userDetails/thumbsup.svg"
      />
      <p class="heading-text">{{ heading }}</p>
    </div>
    <v-divider />

    <div
      :style="{ marginLeft: showProfilePic ? '0px' : '22px' }"
      class="details"
    >
      <div v-if="true" class="profile">
        <img
          style="border-radius: 50%; height: 80px; width: 80px"
          :src="
            data.image
              ? data.image.original
              : 'https://farmstock-assets.s3.amazonaws.com/base/defaultimage/904bdpc9S0aKWdGDzqSIig.png'
          "
          alt=""
        />

        <div class="copy-div">
          <!-- <img src="../../../../assets/userDetails/copyButtton.svg" />
          <p class="link-text">Profile Link</p> -->
        </div>
      </div>
      <div class="question">
        <p>Name</p>
        <p>Acquisition date</p>
        <p>Derived Location</p>
        <p>Mobile Number</p>
        <p>Email ID</p>
      </div>
      <div class="answer">
        <p>{{ data.name }}</p>
        <p>{{ data.acquisition_date }}</p>
        <p>{{ data.derived_location }}</p>
        <p>{{ data.contact_number }}</p>
        <p>{{ data.mail_id }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "userCard",
  props: {
    showProfilePic: Boolean,
    heading: String,
    logo: String,
    data: null,
    defaultImage:
      "https://www.kindpng.com/picc/m/252-2524695_dummy-profile-image-jpg-hd-png-download.pn",
  },
};
</script>
<style lang="scss" scoped>
.main-div {
  height: 283px;
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
  p {
    margin-bottom: 0px;
  }
}
.heading-name {
  height: 52px;
  margin-left: 18px;
  display: flex;
  align-items: center;
  gap: 16px;
}
.details {
  display: flex;
  width: 100%;
  flex-direction: row;
}
.profile {
  display: flex;
  width: 20%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 32px 14px 0px 14px;
}
.heading-text {
  color: #3a3f3a;
  font-size: 16px;
  font-weight: 500;
}
.copy-div {
  display: flex;
  gap: 6px;
  margin-top: 32px;
}
.link-text {
  color: #3190e7;
  font-size: 14px;
}
.question {
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 30%;
  margin-top: 22px;
  p {
    color: #797e79;
    margin: 0;
  }
}
.answer {
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 60%;
  margin-top: 22px;
  p {
    color: #3a3f3a;
    margin: 0;
  }
}
</style>
